import ResizeObserver from 'resize-observer-polyfill';

declare global {
    interface Window {
        ResizeObserver: typeof ResizeObserver | null | undefined;
    }
}

/**
 * Some employees access AtoZ with older browers that don't support ResizeObserver.  Stencil
 * removed the ResizeObserver polyfill in 2.x, which affected tenants in the Spyglass 3.0
 * upgrade.  This file adds the polyfill globally if ResizeObserver is not present on the
 * window object so the fix is transparent to tenants.
 */
if (!window.ResizeObserver) {
    window.ResizeObserver = ResizeObserver;
}
